<!--
 * @Author: lc
 * @Date: 2022-12-14 17:26:04
 * @LastEditors: lc
 * @LastEditTime: 2023-07-18 08:19:19
 * @Description: 
-->
<template >
  <div class="container smallScreen"
       v-if="showStatus==1">
    <Spin size="large"
          fix
          v-if="showLoading"
          class="totalLoad"></Spin>
    <h2 class="tj-title"
        :model="nowtime">数据更新时间：更新于{{nowtime}}</h2>
    <div class="tj-nums-section">
      <div class="tj-nums-row">
        <div class="tj-nums">
          <div class="tj-nums-title">
            <div class="title-name">待支付</div>
            <img src="/img/tongji/unpay.png"
                 alt
                 class="icon" />
          </div>
          <div class="tj-nums-content"
               :model="unpay">
            <div class="content-row hasline">
              <div class="row-item">
                <div class="item-name">商城</div>
                <div class="item-nums"
                     @click="UnPayB2COrder">
                  <span>{{unpay.b2corder}}</span>
                  <Icon type="ios-arrow-forward"
                        size="20"
                        color="rgba(0, 0, 0, 0.9)" />
                </div>
              </div>
              <div class="row-item">
                <div class="item-name">商城自提</div>
                <div class="item-nums"
                     @click="UnPayB2CZtOrder">
                  <span>{{unpay.b2cztorder}}</span>
                  <Icon type="ios-arrow-forward"
                        size="20"
                        color="rgba(0, 0, 0, 0.9)" />
                </div>
              </div>
              <div class="row-item">
                <div class="item-name">定制</div>
                <div class="item-nums"
                     @click="UnPayMadeOrder">
                  <span>{{unpay.madeorder}}</span>
                  <Icon type="ios-arrow-forward"
                        size="20"
                        color="rgba(0, 0, 0, 0.9)" />
                </div>
              </div>
              <div class="row-item">
                <div class="item-name">组局儿</div>
                <div class="item-nums"
                     @click="UnPayyuekanOrder">
                  <span>{{unpay.yuekanorder}}</span>
                  <Icon type="ios-arrow-forward"
                        size="20"
                        color="rgba(0, 0, 0, 0.9)" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tj-nums">
          <div class="tj-nums-title">
            <div class="title-name">待发货</div>
            <img src="/img/tongji/unship.png"
                 alt
                 class="icon" />
          </div>
          <div class="tj-nums-content"
               :model="unship">
            <div class="content-row">
              <div class="row-item">
                <div class="item-name">商城</div>
                <div class="item-nums"
                     @click="UnShipB2COrder">
                  <span>{{unship.b2corder}}</span>
                  <Icon type="ios-arrow-forward"
                        size="20"
                        color="rgba(0, 0, 0, 0.9)" />
                </div>
              </div>
              <div class="row-item">
                <div class="item-name">定制</div>
                <div class="item-nums"
                     @click="UnShipMadeOrder">
                  <span>{{unship.madeorder}}</span>
                  <Icon type="ios-arrow-forward"
                        size="20"
                        color="rgba(0, 0, 0, 0.9)" />
                </div>
              </div>
              <div class="row-item">
                <div class="item-name">
                  <span class>组局儿</span>
                  <Tooltip content="待核销组局儿订单"
                           placement="bottom">
                    <img src="/img/tongji/tip-tu.png"
                         alt
                         class="tip-icon" />
                  </Tooltip>
                </div>
                <div class="item-nums"
                     @click="UnShipyuekanOrder">
                  <span>{{unship.yuekanorder}}</span>
                  <Icon type="ios-arrow-forward"
                        size="20"
                        color="rgba(0, 0, 0, 0.9)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tj-nums-row">
        <div class="tj-nums"
             :model="unreturn">
          <div class="tj-nums-title">
            <div class="title-name">待售后</div>
            <img src="/img/tongji/unreplay.png"
                 alt
                 class="icon" />
          </div>
          <div class="tj-nums-content">
            <div class="content-row">
              <div class="row-item">
                <div class="item-name">商城</div>
                <div class="item-nums"
                     @click="UnReturnB2COrder">
                  <span>{{unreturn.b2corder}}</span>
                  <Icon type="ios-arrow-forward"
                        size="20"
                        color="rgba(0, 0, 0, 0.9)" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tj-nums"
             :model="unreadchat">
          <div class="tj-nums-title">
            <div class="title-name">消息</div>
            <img src="/img/tongji/xiaoxi.png"
                 alt
                 class="icon" />
          </div>
          <div class="tj-nums-content">
            <div class="content-row">
              <div class="row-item">
                <div class="item-name">未读客服消息</div>
                <div class="item-nums"
                     @click="UnReadChats">{{unreadchat}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="xinzeng-section">
      <div class="xinzeng-top">
        <h4 class="biao-name">会员新增：</h4>
        <div class="shaixuan-wrap">
          <div class="shaixuan-item">
            <h4 class="item-name">类型时段：</h4>
            <Select v-model="searchType"
                    style="width:160px">
              <Option :value="1">年</Option>
              <Option :value="2">月</Option>
              <Option :value="3">日</Option>
            </Select>
            <Button type="primary"
                    class="item-btn"
                    @click="searchUserType">查询</Button>
          </div>
          <div class="shaixuan-item">
            <h4 class="item-name">日期时段：</h4>
            <DatePicker type="daterange"
                        placement="bottom-end"
                        placeholder="选时段"
                        style="width: 200px"
                        @on-change="confirmRangeDate" />
            <Button type="primary"
                    class="item-btn"
                    @click="searchUserRangeType">查询</Button>
          </div>
        </div>
      </div>
      <div class="xinzeng-main"
           id="xinzeng-main"
           :style="'width:'+tubiaoWid"></div>
      <div class="skippage">
        <img src="/img/tongji/arrow-qian.png"
             alt
             class="skip-qian"
             @click="updateMain" />
        <img src="/img/tongji/arrow-hou.png"
             alt
             class="skip-hou"
             @click="updateMainHou" />
      </div>
      <Spin size="large"
            fix
            v-if="showUserLoading" />
    </div>
    <div class="xinzeng-section">
      <div class="xinzeng-top">
        <h4 class="biao-name">访客新增：</h4>
        <div class="shaixuan-wrap">
          <div class="shaixuan-item">
            <h4 class="item-name">类型时段：</h4>
            <Select v-model="searchVisitorType"
                    style="width:160px">
              <Option :value="1">年</Option>
              <Option :value="2">月</Option>
              <Option :value="3">日</Option>
            </Select>
            <Button type="primary"
                    class="item-btn"
                    @click="searchClickVisitorType">查询</Button>
          </div>
          <div class="shaixuan-item">
            <h4 class="item-name">日期时段：</h4>
            <DatePicker type="daterange"
                        placement="bottom-end"
                        placeholder="选时段"
                        style="width: 200px"
                        @on-change="confirmVisitorRangeDate" />
            <Button type="primary"
                    class="item-btn"
                    @click="searchVisitorRangeType">查询</Button>
          </div>
        </div>
      </div>
      <div class="xinzeng-main"
           id="xinzeng-main-visitor"
           :style="'width:'+tubiaoWid"></div>
      <div class="skippage">
        <img src="/img/tongji/arrow-qian.png"
             alt
             class="skip-qian"
             @click="updateVisitorMain" />
        <img src="/img/tongji/arrow-hou.png"
             alt
             class="skip-hou"
             @click="updateVisitorMainHou" />
      </div>
      <Spin size="large"
            fix
            v-if="showVisitorLoading" />
    </div>
    <div class="xinzeng-section">
      <div class="xinzeng-top">
        <h4 class="biao-name">销售金额：</h4>
        <div class="shaixuan-wrap">
          <div class="shaixuan-item">
            <h4 class="item-name">类型时段：</h4>
            <Select v-model="searchTypeSaleCash"
                    style="width:160px">
              <Option :value="1">年</Option>
              <Option :value="2">月</Option>
              <Option :value="3">日</Option>
            </Select>
            <Button type="primary"
                    class="item-btn"
                    @click="searchSaleMoney">查询</Button>
          </div>
          <div class="shaixuan-item">
            <h4 class="item-name">日期时段：</h4>
            <DatePicker type="daterange"
                        placement="bottom-end"
                        placeholder="选时段"
                        style="width: 200px"
                        @on-change="confirmRangeDateSaleCash" />
            <Button type="primary"
                    class="item-btn"
                    @click="searchSaleMoneyRange">查询</Button>
          </div>
        </div>
      </div>
      <div class="xinzeng-main"
           id="xinzeng-main-salecash"
           :style="'width:'+tubiaoWid"></div>
      <div class="skippage">
        <img src="/img/tongji/arrow-qian.png"
             alt
             class="skip-qian"
             @click="updateMainSaleCash" />
        <img src="/img/tongji/arrow-hou.png"
             alt
             class="skip-hou"
             @click="updateMainSaleCashHou" />
      </div>
      <Spin size="large"
            fix
            v-if="showSaleMoneyLoading" />
    </div>
    <div class="xinzeng-section">
      <div class="xinzeng-top">
        <h4 class="biao-name">销售数量：</h4>
        <div class="shaixuan-wrap">
          <div class="shaixuan-item">
            <h4 class="item-name">类型时段：</h4>
            <Select v-model="searchTypeSaleNum"
                    style="width:160px">
              <Option :value="1">年</Option>
              <Option :value="2">月</Option>
              <Option :value="3">日</Option>
            </Select>
            <Button type="primary"
                    class="item-btn"
                    @click="searchSaleNum">查询</Button>
          </div>
          <div class="shaixuan-item">
            <h4 class="item-name">日期时段：</h4>
            <DatePicker type="daterange"
                        placement="bottom-end"
                        placeholder="选时段"
                        style="width: 200px"
                        @on-change="confirmRangeDateSaleNum" />
            <Button type="primary"
                    class="item-btn"
                    @click="searchSaleNumRange">查询</Button>
          </div>
        </div>
      </div>
      <div class="xinzeng-main"
           id="xinzeng-main-salenum"
           :style="'width:'+tubiaoWid"></div>
      <div class="skippage">
        <img src="/img/tongji/arrow-qian.png"
             alt
             class="skip-qian"
             @click="updateMainSaleNum" />
        <img src="/img/tongji/arrow-hou.png"
             alt
             class="skip-hou"
             @click="updateMainSaleNumHou" />
      </div>
      <Spin size="large"
            fix
            v-if="showSaleNumLoading" />
    </div>
  </div>
</template>
  
  <script>
import * as echarts from "echarts";
export default {
  data () {
    return {
      showLoading: true,
      unpay: {},
      unship: {},
      unreturn: {},
      xinzenguser: {},
      nowtime: "",
      mainendtime: "",
      mainstarttime: "",
      usersendtime: "",
      userstarttime: "",
      userrangestarttime: "",
      userrangeendtime: "",
      userscounttimereal: "",
      userscounttimerealhou: "",
      sorces: [],

      visitorsorces: [],
      visitorendtime: "",
      visitorstarttime: "",
      visitorrangestarttime: "",
      visitorrangeendtime: "",
      visitorcounttimereal: "",
      visitorcounttimerealhou: "",

      salemoneyendtime: "",
      salemoneysorces: [],
      salemoneystarttime: "",
      salemoneyrangestarttime: "",
      salemoneyrangeendtime: "",
      salemoneycounttimereal: "",
      salemoneycounttimerealhou: "",

      salenumendtime: "",
      salenumsorce: [],
      salenumstarttime: "",
      salenumrangestarttime: "",
      salenumrangeendtime: "",
      salenumcounttimereal: "",
      salenumcounttimerealhou: "",

      unreadchat: 0,
      searchType: 3, // 年月日查询条件
      searchVisitorType: 3, // 访问者年月日查询条件
      configColor: [
        "#FF6A6F",
        "#FFC284",
        "#8AB5FF",
        "#FF98E9",
        "#BCFFC2",
        "#D5BCFF"
      ],
      searchTypeSaleCash: 3, // 销售金额 年月日查询条件
      searchTypeSaleNum: 3, // 销售数量 年月日查询条件
      showUserLoading: false, // 局部loading 会员
      showVisitorLoading: false, // 局部loading 访客
      showSaleMoneyLoading: false, // 局部loading 销售金额
      showSaleNumLoading: false, // 局部loading 销售数量
      tubiaoWid: null, // 图表位置
      showStatus: 0
    };
  },
  created () {
    this.showStatus = this.$store.getters.admin_role;
    if (this.showStatus) {
      // 公共接口
      this.getCommonData();
    }
  },
  mounted () {
    // 屏幕宽
    let screenWid = document.body.clientWidth;
    // 估算的图表位置
    this.tubiaoWid = screenWid - 420 + "px";
  },
  methods: {
    //订单跳转
    UnPayB2COrder () {
      this.$router.push("/goods/order/0/0/0/1");
    },
    UnPayB2BOrder () {
      this.$router.push("/salegoods/order/1/0/0/1");
    },
    UnPayParkOrder () {
      this.$router.push("/parkgoods/order/2/0/0/1");
    },
    UnPayB2CZtOrder () {
      this.$router.push("/goods/ztorder/0/0/1");
    },
    UnPayB2BZtOrder () {
      this.$router.push("/salegoods/ztorder/1/0/1");
    },
    UnPayParkZtOrder () {
      this.$router.push("/parkgoods/ztorder/2/0/1");
    },
    UnPayMadeOrder () {
      this.$router.push("/madeorder/list/0/0/1");
    },
    UnPayyuekanOrder () {
      this.$router.push("/lives/orderlist/0/0/1");
    },
    UnPaymangheOrder () {
      this.$router.push("/boxorder/list/0/0");
    },
    UnPaymanghemadeOrder () {
      this.$router.push("/manghemadeorder/list/0/0");
    },
    UnPaymangheShopOrder () {
      this.$router.push("/mangheshopgoodorder/payorderlist/0/0");
    },
    UnShipB2COrder () {
      this.$router.push("/goods/order/0/2/0/1");
    },
    UnShipB2BOrder () {
      this.$router.push("/salegoods/order/1/2/0/1");
    },
    UnShipParkOrder () {
      this.$router.push("/parkgoods/order/2/2/0/1");
    },
    UnShipMadeOrder () {
      this.$router.push("/madeorder/list/3/0/1");
    },
    UnShipyuekanOrder () {
      this.$router.push("/lives/orderlist/2/0/1");
    },
    UnShipmangheOrder () {
      this.$router.push("/manghegoodorder/list/0/0");
    },
    UnShipmangheshopOrder () {
      this.$router.push("/mangheshopgoodorder/list/0/0");
    },
    UnShipmanghemadeOrder () {
      this.$router.push("/manghemadegoodorder/list/0/0");
    },
    UnReturnB2COrder () {
      this.$router.push("/b2cordergood/list/0/0");
    },
    UnReturnB2BOrder () {
      this.$router.push("/b2cordergood/list/1/0");
    },
    UnReturnParkOrder () {
      this.$router.push("/b2cordergood/list/2/0");
    },
    UnReturnmangheshopOrder () {
      this.$router.push("/mangheshopgoodreturnorder/list/0");
    },
    UnReadChats () {
      this.$router.push("/msg/customer/list");
    },
    //获取当前时间的统计数据
    getCommonData: function () {
      let that = this;
      this.$api.maincount.index().then(res => {
        this.showLoading = false;
        if (res.code == 200) {
          this.unpay = res.result.unpay;
          this.unship = res.result.unship;
          this.unreturn = res.result.unreturn;
          this.unreadchat = res.result.unreadchat;
          this.nowtime = res.result.nowtime;
          this.mainendtime = res.result.endtime;
          this.mainstarttime = res.result.starttime;
          this.getData(res.result.users);
          this.getVisitorData(res.result.visitor);
          this.getDataSaleCash(res.result.salemoney);
          this.getDataSaleNum(res.result.salenum);
        }
      });
    },
    // 创建图表
    createMain (xData, seriesData, obj) {
      let that = this;
      let chartDom = document.getElementById("xinzeng-main");
      let myChart = echarts.init(chartDom);
      // 点选legend
      myChart.on("legendselectchanged", function (params) {
        // 点选图例
        let selected = params.selected;
        that.updateMain(selected, 1);
      });
      let option;

      option = {
        legend: {
          orient: "vertical",
          right: "0",
          selected: this.sorces
        },
        tooltip: {},
        color: that.configColor, // 颜色配置
        xAxis: {
          type: "category",
          name: "时间",
          data: xData,
          nameTextStyle: {
            color: "#9E9E9E"
          },
          axisLine: {
            lineStyle: {
              color: "#F9F9F9"
            }
          },
          axisLabel: {
            color: "#9E9E9E"
          }
        },
        yAxis: [
          {
            type: "value",
            name: "数量",
            nameTextStyle: {
              color: "#9E9E9E"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#F9F9F9"
              }
            },
            axisLabel: {
              color: "#9E9E9E"
            }
          },
          {
            type: "value",
            name: "总趋势"
          }
        ],
        series: seriesData
      };
      option && myChart.setOption(option);
    },
    // 请求用户数据
    getData (datalist, obj) {
      let that = this;
      // echarts实例
      echarts.init(document.getElementById("xinzeng-main")).dispose(); // 销毁实例
      let xData = datalist.xDatas;
      let seriesData = [
        {
          type: "bar",
          name: "总平台",
          data: datalist.plat,
          label: {
            show: true, // 类型多,显示出来会乱
            position: "top",
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        {
          type: "bar",
          name: "APP",
          data: datalist.app,
          label: {
            show: true,
            position: "top",
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        {
          type: "bar",
          name: "定制",
          data: datalist.custommade,
          label: {
            show: true,
            position: "top",
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        // {
        //   type: "bar",
        //   name: "锦盒",
        //   data: datalist.manghe,
        //   label: {
        //     show: true,
        //     position: "top",
        //     color: "rgba(0, 0, 0, 0.9)"
        //   },
        //   barGap: "30%",
        //   itemStyle: {
        //     borderRadius: [5, 5, 0, 0]
        //   },
        //   barWidth: "20px"
        // },
        {
          type: "bar",
          name: "商城",
          data: datalist.newminiprogram,
          label: {
            show: true,
            position: "top",
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        {
          type: "line",
          smooth: true,
          lineStyle: {
            color: "#1EE7FF",
            width: 4
          },
          itemStyle: {
            color: "#4080FF"
          },
          label: {
            show: true,
            position: "top",
            offset: [10, 0],
            color: "rgba(0, 0, 0, 0.9)"
          },
          symbolSize: [12, 12],
          data: datalist.totalnum
        }
      ];
      that.createMain(xData, seriesData, obj);
    },
    // 用户统计时段选择
    confirmRangeDate (val) {
      this.userrangestarttime = val[0];
      this.userrangeendtime = val[1];
    },
    searchUserRangeType: function () {
      this.showUserLoading = true;
      this.$api.maincount
        .userscount({
          type: 4,
          starttime: this.userrangestarttime,
          endtime: this.userrangeendtime,
          sorces: this.sorces,
          leftorright: 3
        })
        .then(res => {
          this.showUserLoading = false;
          if (res.code == 200) {
            this.getData(res.result.users);
          }
        });
    },
    // 更新用户图表
    updateMain (obj, index) {
      let that = this;
      if (index == 1) {
        this.sorces = obj;
      }
      if (this.usersendtime == "") {
        if (index == 1) {
          this.userscounttimereal = this.mainstarttime;
          this.leftorright = 3;
        } else {
          this.userscounttimereal = this.mainendtime;
          this.leftorright = 1;
        }
      } else {
        if (index == 1) {
          this.userscounttimereal = this.mainstarttime;
          this.leftorright = 3;
        } else {
          this.userscounttimereal = this.usersendtime;
          this.leftorright = 1;
        }
      }
      this.userindex = index;
      this.showUserLoading = true;
      // 点选切换的参数,可以在这里组
      // let cate = '';
      this.$api.maincount
        .userscount({
          type: this.searchType,
          endtime: this.userscounttimereal,
          sorces: this.sorces,
          leftorright: this.leftorright
        })
        .then(res => {
          this.showUserLoading = false;
          if (res.code == 200) {
            this.usersendtime = res.result.endtime;
            this.userstarttime = res.result.starttime;
            this.sorces = res.result.sorces;
            console.log(this.sorces);
            this.getData(res.result.users, obj);
          }
        });
    },
    updateMainHou () {
      let that = this;
      if (this.userstarttime == "") {
        this.userscounttimerealhou = this.mainstarttime;
        if (this.userindex == 1) {
          this.leftorright = 3;
        } else {
          this.leftorright = 2;
        }
      } else {
        this.userscounttimerealhou = this.userstarttime;
        this.leftorright = 2;
      }
      this.showUserLoading = true;
      this.$api.maincount
        .userscount({
          type: this.searchType,
          endtime: this.userscounttimerealhou,
          sorces: this.sorces,
          leftorright: this.leftorright
        })
        .then(res => {
          this.showUserLoading = false;
          if (res.code == 200) {
            this.usersendtime = res.result.endtime;
            this.userstarttime = res.result.starttime;
            this.sorces = res.result.sorces;
            this.getData(res.result.users);
          }
        });
    },
    //选择统计用户的筛选条件
    searchUserType: function () {
      this.showUserLoading = true;
      this.$api.maincount
        .userscount({
          type: this.searchType,
          endtime: this.nowtime,
          sorces: this.sorces,
          leftorright: 3
        })
        .then(res => {
          this.showUserLoading = false;
          if (res.code == 200) {
            this.usersendtime = res.result.endtime;
            this.userstarttime = res.result.starttime;
            this.sorces = res.result.sorces;
            this.getData(res.result.users);
          }
        });
    },
    // 创建图表
    createVisitorMain (xData, seriesData) {
      let that = this;
      let chartDom = document.getElementById("xinzeng-main-visitor");
      let myChart = echarts.init(chartDom);
      // 点选legend
      myChart.on("legendselectchanged", function (params) {
        // 点选图例
        let selected = params.selected;
        that.updateVisitorMain(selected, 1);
      });
      let option;
      option = {
        legend: {
          orient: "vertical",
          right: "0",
          selected: this.visitorsorces
        },
        tooltip: {},
        color: that.configColor, // 颜色配置
        xAxis: {
          type: "category",
          name: "时间",
          data: xData,
          nameTextStyle: {
            color: "#9E9E9E"
          },
          axisLine: {
            lineStyle: {
              color: "#F9F9F9"
            }
          },
          axisLabel: {
            color: "#9E9E9E"
          }
        },
        yAxis: [
          {
            type: "value",
            name: "数量",
            nameTextStyle: {
              color: "#9E9E9E"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#F9F9F9"
              }
            },
            axisLabel: {
              color: "#9E9E9E"
            }
          },
          {
            type: "value",
            name: "总趋势"
          }
        ],
        series: seriesData
      };
      option && myChart.setOption(option);
    },
    //请求访客数据
    getVisitorData (datalist) {
      let that = this;
      // echarts实例
      echarts.init(document.getElementById("xinzeng-main-visitor")).dispose(); // 销毁实例
      let xData = datalist.xDatas;
      let seriesData = [
        {
          type: "bar",
          name: "总平台",
          data: datalist.plat,
          label: {
            show: true, // 类型多,显示出来会乱
            position: "top",
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        {
          type: "bar",
          name: "APP",
          data: datalist.app,
          label: {
            show: true,
            position: "top",
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        {
          type: "bar",
          name: "定制",
          data: datalist.custommade,
          label: {
            show: true,
            position: "top",
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        // {
        //   type: "bar",
        //   name: "锦盒",
        //   data: datalist.manghe,
        //   label: {
        //     show: true,
        //     position: "top",
        //     color: "rgba(0, 0, 0, 0.9)"
        //   },
        //   barGap: "30%",
        //   itemStyle: {
        //     borderRadius: [5, 5, 0, 0]
        //   },
        //   barWidth: "20px"
        // },
        {
          type: "bar",
          name: "商城",
          data: datalist.newminiprogram,
          label: {
            show: true,
            position: "top",
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        {
          type: "line",
          smooth: true,
          lineStyle: {
            color: "#1EE7FF",
            width: 4
          },
          itemStyle: {
            color: "#4080FF"
          },
          label: {
            show: true,
            position: "top",
            offset: [10, 0],
            color: "rgba(0, 0, 0, 0.9)"
          },
          symbolSize: [12, 12],
          data: datalist.totalnum
        }
      ];
      that.createVisitorMain(xData, seriesData);
    },
    // 用户统计时段选择
    confirmVisitorRangeDate (val) {
      this.visitorrangestarttime = val[0];
      this.visitorrangeendtime = val[1];
    },
    searchVisitorRangeType: function () {
      this.showVisitorLoading = true;
      this.$api.maincount
        .visitornumcount({
          type: 4,
          starttime: this.visitorrangestarttime,
          endtime: this.visitorrangeendtime,
          sorces: this.visitorsorces,
          leftorright: 3
        })
        .then(res => {
          this.showVisitorLoading = false;
          if (res.code == 200) {
            this.visitorsorces = res.result.sorces;
            this.getVisitorData(res.result.visitor);
          }
        });
    },
    // 更新用户图表
    updateVisitorMain (obj, index) {
      let that = this;
      if (index == 1) {
        this.visitorsorces = obj;
      }
      if (this.visitorendtime == "") {
        if (index == 1) {
          this.visitorcounttimereal = this.mainstarttime;
          this.leftorright = 3;
        } else {
          this.visitorcounttimereal = this.mainendtime;
          this.leftorright = 1;
        }
      } else {
        if (index == 1) {
          this.visitorcounttimereal = this.mainstarttime;
          this.leftorright = 3;
        } else {
          this.visitorcounttimereal = this.visitorendtime;
          this.leftorright = 1;
        }
      }
      this.showVisitorLoading = true;
      this.$api.maincount
        .visitornumcount({
          type: this.searchVisitorType,
          endtime: this.visitorcounttimereal,
          sorces: this.visitorsorces,
          leftorright: this.leftorright
        })
        .then(res => {
          this.showVisitorLoading = false;
          if (res.code == 200) {
            this.visitorendtime = res.result.endtime;
            this.visitorstarttime = res.result.starttime;
            this.visitorsorces = res.result.sorces;
            this.getVisitorData(res.result.visitor);
          }
        });
    },
    updateVisitorMainHou () {
      let that = this;
      if (this.visitorstarttime == "") {
        this.visitorcounttimerealhou = this.mainstarttime;
      } else {
        this.visitorcounttimerealhou = this.visitorstarttime;
      }
      this.showVisitorLoading = true;
      this.$api.maincount
        .visitornumcount({
          type: this.searchVisitorType,
          endtime: this.visitorcounttimerealhou,
          sorces: this.visitorsorces,
          leftorright: 2
        })
        .then(res => {
          this.showVisitorLoading = false;
          if (res.code == 200) {
            this.visitorendtime = res.result.endtime;
            this.visitorstarttime = res.result.starttime;
            this.visitorsorces = res.result.sorces;
            this.getVisitorData(res.result.visitor);
          }
        });
    },
    //选择统计访客的筛选条件
    searchClickVisitorType: function () {
      this.showVisitorLoading = true;
      this.$api.maincount
        .visitornumcount({
          type: this.searchVisitorType,
          endtime: this.nowtime,
          sorces: this.visitorsorces,
          leftorright: 3
        })
        .then(res => {
          this.showVisitorLoading = false;
          if (res.code == 200) {
            this.visitorendtime = res.result.endtime;
            this.visitorstarttime = res.result.starttime;
            this.visitorsorces = res.result.sorces;
            this.getVisitorData(res.result.visitor);
          }
        });
    },
    // 销售数量的创建图表
    createMainSaleNum (xData, seriesData) {
      let that = this;
      let chartDom = document.getElementById("xinzeng-main-salenum");
      let myChart = echarts.init(chartDom);
      // 点选legend
      myChart.on("legendselectchanged", function (params) {
        // 点选图例
        let selected = params.selected;
        that.updateMainSaleNum(selected, 1);
      });
      let option;
      option = {
        legend: {
          orient: "vertical",
          right: "0",
          selected: this.salenumsorce
        },
        tooltip: {},
        color: that.configColor, // 颜色配置
        xAxis: {
          type: "category",
          name: "时间",
          data: xData,
          nameTextStyle: {
            color: "#9E9E9E"
          },
          axisLine: {
            lineStyle: {
              color: "#F9F9F9"
            }
          },
          axisLabel: {
            color: "#9E9E9E"
          }
        },
        yAxis: [
          {
            type: "value",
            name: "数量",
            nameTextStyle: {
              color: "#9E9E9E"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#F9F9F9"
              }
            },
            axisLabel: {
              color: "#9E9E9E"
            }
          },
          {
            type: "value",
            name: "总趋势"
          }
        ],
        series: seriesData
      };
      option && myChart.setOption(option);
    },
    // 销售数量的请求数据
    getDataSaleNum (datalist) {
      let that = this;
      // echarts实例
      echarts.init(document.getElementById("xinzeng-main-salenum")).dispose(); // 销毁实例
      let xData = datalist.xDatas;
      let seriesData = [
        {
          type: "bar",
          name: "商城",
          data: datalist.shop,
          label: {
            show: true, // 类型多,显示出来会乱
            position: "top",
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        // {
        //   type: "bar",
        //   name: "兑换",
        //   data: datalist.flshop,
        //   label: {
        //     show: true,
        //     position: "top",
        //     color: "rgba(0, 0, 0, 0.9)"
        //   },
        //   barGap: "30%",
        //   itemStyle: {
        //     borderRadius: [5, 5, 0, 0]
        //   },
        //   barWidth: "20px"
        // },
        // {
        //   type: "bar",
        //   name: "园区",
        //   data: datalist.parkshop,
        //   label: {
        //     show: true,
        //     position: "top",
        //     color: "rgba(0, 0, 0, 0.9)"
        //   },
        //   barGap: "30%",
        //   itemStyle: {
        //     borderRadius: [5, 5, 0, 0]
        //   },
        //   barWidth: "20px"
        // },
        {
          type: "bar",
          name: "定制",
          data: datalist.custommade,
          label: {
            show: true,
            position: "top",
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        {
          type: "bar",
          name: "组局儿",
          data: datalist.yuekan,
          label: {
            show: true,
            position: "top",
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        // {
        //   type: "bar",
        //   name: "锦盒",
        //   data: datalist.manghe,
        //   label: {
        //     show: true,
        //     position: "top",
        //     color: "rgba(0, 0, 0, 0.9)"
        //   },
        //   barGap: "30%",
        //   itemStyle: {
        //     borderRadius: [5, 5, 0, 0]
        //   },
        //   barWidth: "20px"
        // },
        {
          type: "line",
          smooth: true,
          lineStyle: {
            color: "#1EE7FF",
            width: 4
          },
          itemStyle: {
            color: "#4080FF"
          },
          label: {
            show: true,
            position: "top",
            offset: [10, 0],
            color: "rgba(0, 0, 0, 0.9)"
          },
          symbolSize: [12, 12],
          data: datalist.totalnum
        }
      ];
      that.createMainSaleNum(xData, seriesData);
    },
    // 销售数量的时段选择
    confirmRangeDateSaleNum (val) {
      this.salenumrangestarttime = val[0];
      this.salenumrangeendtime = val[1];
    },
    //选择统计销售数量的筛选条件
    searchSaleNum: function () {
      this.showSaleNumLoading = true;
      this.$api.maincount
        .salenumcount({
          type: this.searchTypeSaleNum,
          endtime: this.nowtime,
          sorces: this.salenumsorce,
          leftorright: 3
        })
        .then(res => {
          this.showSaleNumLoading = false;
          if (res.code == 200) {
            this.salenumendtime = res.result.endtime;
            this.salenumtarttime = res.result.starttime;
            this.salenumsorce = res.result.sorces;
            this.getDataSaleNum(res.result.salenum);
          }
        });
    },
    searchSaleNumRange: function () {
      this.showSaleNumLoading = true;
      this.$api.maincount
        .salenumcount({
          type: 4,
          starttime: this.salenumrangestarttime,
          endtime: this.salenumrangeendtime,
          sorces: this.salenumsorce,
          leftorright: 3
        })
        .then(res => {
          this.showSaleNumLoading = false;
          if (res.code == 200) {
            this.getDataSaleNum(res.result.salenum);
          }
        });
    },
    // 销售数量的更新图表
    updateMainSaleNum (obj, indexx) {
      let that = this;
      if (indexx == 1) {
        this.salenumsorce = obj;
      }
      this.salenumindex = indexx;
      if (this.salenumendtime == "") {
        if (indexx == 1) {
          this.salenumcounttimereal = this.mainstarttime;
          this.leftorright = 3;
        } else {
          this.salenumcounttimereal = this.mainendtime;
          this.leftorright = 1;
        }
      } else {
        if (indexx == 1) {
          this.salenumcounttimereal = this.mainstarttime;
          this.leftorright = 3;
        } else {
          this.salenumcounttimereal = this.salenumendtime;
          this.leftorright = 1;
        }
      }
      console.log(this.salenumcounttimereal);
      this.showSaleNumLoading = true;
      this.$api.maincount
        .salenumcount({
          type: this.searchTypeSaleNum,
          endtime: this.salenumcounttimereal,
          sorces: this.salenumsorce,
          leftorright: this.leftorright
        })
        .then(res => {
          this.showSaleNumLoading = false;
          if (res.code == 200) {
            this.salenumendtime = res.result.endtime;
            this.salenumstarttime = res.result.starttime;
            this.salenumsorce = res.result.sorces;
            this.getDataSaleNum(res.result.salenum, obj);
          }
        });
    },
    updateMainSaleNumHou () {
      let that = this;
      if (this.salenumstarttime == "") {
        this.salenumcounttimerealhou = this.mainstarttime;
      } else {
        this.salenumcounttimerealhou = this.salenumstarttime;
      }
      this.showSaleNumLoading = true;
      this.$api.maincount
        .salenumcount({
          type: this.searchTypeSaleNum,
          endtime: this.salenumcounttimerealhou,
          sorces: this.salenumsorce,
          leftorright: 2
        })
        .then(res => {
          this.showSaleNumLoading = false;
          if (res.code == 200) {
            this.salenumendtime = res.result.endtime;
            this.salenumstarttime = res.result.starttime;
            this.salenumsorce = res.result.sorces;
            this.getDataSaleNum(res.result.salenum);
          }
        });
    },
    // 销售金额的创建图表
    createMainSaleCash (xData, seriesData) {
      let that = this;
      let chartDom = document.getElementById("xinzeng-main-salecash");
      let myChart = echarts.init(chartDom);
      // 点选legend
      myChart.on("legendselectchanged", function (params) {
        // 点选图例
        let selected = params.selected;
        that.updateMainSaleCash(selected, 1);
      });
      let option;
      option = {
        legend: {
          orient: "vertical",
          right: "0",
          selected: this.salemoneysorces
        },
        tooltip: {},
        color: that.configColor, // 颜色配置
        xAxis: {
          type: "category",
          name: "时间",
          data: xData,
          nameTextStyle: {
            color: "#9E9E9E"
          },
          axisLine: {
            lineStyle: {
              color: "#F9F9F9"
            }
          },
          axisLabel: {
            color: "#9E9E9E"
          }
        },
        yAxis: [
          {
            type: "value",
            name: "金额",
            nameTextStyle: {
              color: "#9E9E9E"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#F9F9F9"
              }
            },
            axisLabel: {
              color: "#9E9E9E"
            }
          },
          {
            type: "value",
            name: "总趋势"
          }
        ],
        series: seriesData
      };
      option && myChart.setOption(option);
    },
    // 销售金额的请求数据
    getDataSaleCash (datalist) {
      let that = this;
      // echarts实例
      echarts.init(document.getElementById("xinzeng-main-salecash")).dispose(); // 销毁实例
      let xData = datalist.xDatas;
      let seriesData = [
        {
          type: "bar",
          name: "商城",
          data: datalist.shop,
          label: {
            show: false, // 类型多,显示出来会乱
            position: "top", // position: ['50%', '50%'] top
            offset: [0, 0],
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        // {
        //   type: "bar",
        //   name: "兑换",
        //   data: datalist.flshop,
        //   label: {
        //     show: false,
        //     position: "top",
        //     offset: [0, 0],
        //     color: "rgba(0, 0, 0, 0.9)"
        //   },
        //   barGap: "30%",
        //   itemStyle: {
        //     borderRadius: [5, 5, 0, 0]
        //   },
        //   barWidth: "20px"
        // },
        // {
        //   type: "bar",
        //   name: "园区",
        //   data: datalist.parkshop,
        //   label: {
        //     show: false,
        //     position: "top",
        //     offset: [0, 0],
        //     color: "rgba(0, 0, 0, 0.9)"
        //   },
        //   barGap: "30%",
        //   itemStyle: {
        //     borderRadius: [5, 5, 0, 0]
        //   },
        //   barWidth: "20px"
        // },
        {
          type: "bar",
          name: "定制",
          data: datalist.custommade,
          label: {
            show: false,
            position: "top",
            offset: [0, 0],
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        {
          type: "bar",
          name: "组局儿",
          data: datalist.yuekan,
          label: {
            show: false,
            position: "top",
            offset: [0, 0],
            color: "rgba(0, 0, 0, 0.9)"
          },
          barGap: "30%",
          itemStyle: {
            borderRadius: [5, 5, 0, 0]
          },
          barWidth: "20px"
        },
        // {
        //   type: "bar",
        //   name: "锦盒",
        //   data: datalist.manghe,
        //   label: {
        //     show: false,
        //     position: "top",
        //     offset: [0, 0],
        //     color: "rgba(0, 0, 0, 0.9)"
        //   },
        //   barGap: "30%",
        //   itemStyle: {
        //     borderRadius: [5, 5, 0, 0]
        //   },
        //   barWidth: "20px"
        // },
        {
          type: "line",
          smooth: true,
          lineStyle: {
            color: "#1EE7FF",
            width: 4
          },
          itemStyle: {
            color: "#4080FF"
          },
          label: {
            show: true,
            position: "top",
            offset: [0, -5],
            color: "rgba(0, 0, 0, 0.9)"
          },
          symbolSize: [12, 12],
          data: datalist.totalnum
        }
      ];
      that.createMainSaleCash(xData, seriesData);
    },
    //选择统计销售金额的筛选条件
    searchSaleMoney: function () {
      this.showSaleMoneyLoading = true;
      this.$api.maincount
        .salemoneycount({
          type: this.searchTypeSaleCash,
          endtime: this.nowtime,
          sorces: this.salemoneysorces,
          leftorright: 3
        })
        .then(res => {
          this.showSaleMoneyLoading = false;
          if (res.code == 200) {
            this.salemoneyendtime = res.result.endtime;
            this.salemoneytarttime = res.result.starttime;
            this.salemoneysorces = res.result.sorces;
            this.getDataSaleCash(res.result.salemoney);
          }
        });
    },
    // 销售金额的更新图表
    updateMainSaleCash (obj, index) {
      let that = this;
      if (index == 1) {
        this.salemoneysorces = obj;
      }
      if (this.salemoneyendtime == "") {
        if (index == 1) {
          this.salemoneycounttimereal = this.mainstarttime;
          this.leftorright = 3;
        } else {
          this.salemoneycounttimereal = this.mainendtime;
          this.leftorright = 1;
        }
      } else {
        if (index == 1) {
          this.salemoneycounttimereal = this.mainstarttime;
          this.leftorright = 3;
        } else {
          this.salemoneycounttimereal = this.salemoneyendtime;
          this.leftorright = 1;
        }
      }
      this.showSaleMoneyLoading = true;
      this.$api.maincount
        .salemoneycount({
          type: this.searchTypeSaleCash,
          endtime: this.salemoneycounttimereal,
          sorces: this.salemoneysorces,
          leftorright: this.leftorright
        })
        .then(res => {
          this.showSaleMoneyLoading = false;
          if (res.code == 200) {
            this.salemoneyendtime = res.result.endtime;
            this.salemoneystarttime = res.result.starttime;
            this.salemoneysorces = res.result.sorces;
            this.getDataSaleCash(res.result.salemoney);
          }
        });
    },
    updateMainSaleCashHou () {
      let that = this;
      if (this.salemoneystarttime == "") {
        this.salemoneycounttimerealhou = this.mainstarttime;
      } else {
        this.salemoneycounttimerealhou = this.salemoneystarttime;
      }
      this.showSaleMoneyLoading = true;
      this.$api.maincount
        .salemoneycount({
          type: this.searchTypeSaleCash,
          endtime: this.salemoneycounttimerealhou,
          sorces: this.salemoneysorces,
          leftorright: 2
        })
        .then(res => {
          this.showSaleMoneyLoading = false;
          if (res.code == 200) {
            this.salemoneyendtime = res.result.endtime;
            this.salemoneystarttime = res.result.starttime;
            this.salemoneysorces = res.result.sorces;

            this.getDataSaleCash(res.result.salemoney);
          }
        });
    },
    // 销售金额的时段选择
    confirmRangeDateSaleCash (val) {
      this.salemoneyrangestarttime = val[0];
      this.salemoneyrangeendtime = val[1];
    },
    searchSaleMoneyRange: function () {
      this.showSaleMoneyLoading = true;
      this.$api.maincount
        .salemoneycount({
          type: 4,
          starttime: this.salemoneyrangestarttime,
          endtime: this.salemoneyrangeendtime,
          sorces: this.salemoneysorces,
          leftorright: 3
        })
        .then(res => {
          this.showSaleMoneyLoading = false;
          if (res.code == 200) {
            this.salemoneysorces = res.result.sorces;
            this.getDataSaleCash(res.result.salemoney);
          }
        });
    },

    // 路由跳转
    routeLinkFun (url, obj) {
      this.$router.push({
        path: url,
        query: obj
      });
    }
  }
};
  </script>
  
  <style scoped>
/deep/.totalLoad .ivu-spin-main {
  top: 50vh !important;
}
</style>
  
